module.exports = __webpack_public_path__ + "img/sleeve_opening.963ad497.png";